import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["role", "tenantAssignments"]

  connect() {
    this.toggleTenantAssignments()
  }

  toggleTenantAssignments() {
    this.tenantAssignmentsTarget.hidden = !["tenant_admin", "tenant_user"].includes(this.roleTarget.value)
  }
}
